import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Box } from '../../../design/css';
import { Text } from '../css';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import FormSummaryRow from './../../../form/formSummaryRow'
import { getButton } from '../../../srtDashboard/utils';
import OrderAssignee from './orderAssignee';

const OrderHeader = ({
  order
}) => {
  const localizedString = useLocalizedStringsContext();
  const {
    ORDERS: {
      orderId,
      orderStatus,
      statusText,
      businessLegalName,
      orderProduct,
    }
  } = localizedString;
  return (
    <>
      <FormSummaryRow key="orderId" label={orderId} value={order.orderId} />
      <FormSummaryRow
        key="businessName"
        label={businessLegalName}
        value={order.businessLegalName}
      />
      <FormSummaryRow key="status" label={orderStatus} value={statusText[order.status]} />
      <FormSummaryRow key="orderProduct" label={orderProduct} value={order.productInOrderFor} />
    </>
  );
};

OrderHeader.propTypes = {
  userRights: PropTypes.shape({
    isStatusEditable: PropTypes.bool,
    canAssignOrder: PropTypes.bool
  }).isRequired,
  order: PropTypes.shape({
    id: PropTypes.number,
    orderId: PropTypes.string,
    status: PropTypes.string,
    businessLegalName: PropTypes.string
  }).isRequired,
  defaultAssignee: PropTypes.arrayOf(PropTypes.string).isRequired,
  assignee: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAssigneeChange: PropTypes.func.isRequired,
  onClickSave: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number
    })
  ).isRequired
};

export default OrderHeader;
